import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "./OrderHistory.css";
import { toast } from "react-toastify";
import logo from "../../asset/logo512.png";

function OrderHistory() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [reviewProduct, setReviewProduct] = useState(null);
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");

    const openReviewModal = (productId) => {
        setReviewProduct(productId);
    };
    const submitReview = async () => {
        try {
            await axiosInstance.post("/reviews/", {
                product: reviewProduct,
                rating: rating,
                comment: comment
            });

            toast.success("Review submitted ⭐");

            setReviewProduct(null);
            setRating(0);
            setComment("");

            const res = await axiosInstance.get("/payment/order-history/");
            setOrders(res.data);

        } catch (err) {
            toast.error("You already reviewed this product");
        }
    };



    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance
            .get("/payment/order-history/")
            .then(res => setOrders(res.data))
            .catch(() => navigate("/login"))
            .finally(() => setLoading(false));
    }, [navigate]);
    if (loading) {
        return (
            <div className="order-loading">
                <img src={logo} alt="Loading..." className="loading-logo" />
                <p>Loading your orders...</p>
            </div>
        );
    }
    const downloadInvoice = async (orderId) => {
        try {
            const response = await axiosInstance.get(
                `/payment/invoice/${orderId}/`,
                { responseType: "blob" }
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `invoice_${orderId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Invoice download failed", error);
        }
    };

    if (orders.length === 0) {
        return (
            <div className="order-empty">
                <img
                    src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
                    alt="No Orders"
                    className="order-empty-img"
                />

                <h2>No Orders Yet 🧾</h2>
                <p>You haven't placed any orders yet.</p>

                <button
                    className="order-shop-btn"
                    onClick={() => navigate("/")}
                >
                    Start Shopping
                </button>
            </div>
        );
    }
    return (
        <div className="oh-page">
            <h2 className="oh-title">My Orders 🛒🛍️</h2>

            {orders.map(order => (
                <div key={order.id} className="oh-card">

                    {/* HEADER */}
                    <div className="oh-header">
                        <div>
                            {/* <strong>Order #{order.id}</strong> */}
                            <span className="oh-date">
                                {new Date(order.created_at).toDateString()}
                            </span>
                        </div>

                        <div className="oh-badges">
                            <span className={`oh-payment ${order.is_paid ? "paid" : "unpaid"}`}>
                                {order.is_paid ? "Paid💵" : "Unpaid"}
                            </span>

                            <span className={`oh-delivery ${order.delivery_status}`}>
                                {order.delivery_status === "pending" && (
                                    <>
                                        ⏳ Pending
                                    </>
                                )}

                                {order.delivery_status === "shipped" && (
                                    <>
                                        🚚 Shipped
                                    </>
                                )}
                                {order.delivery_status === "delivered" && (
                                    <>
                                        ✅ Delivered
                                    </>
                                )}

                            </span>

                        </div>
                    </div>

                    <div className="oh-body">
                        <div className="oh-items">
                            {order.items.map((item, index) => (
                                <div
                                    key={index}
                                    className="oh-item"
                                    onClick={() => navigate(`/product/${item.product_id}`)}
                                    style={{ cursor: "pointer" }} // show pointer on hover
                                >
                                    <img
                                        src={item.image}
                                        alt={item.product_name}
                                        className="oh-img"
                                    />
                                    <div className="oh-info">
                                        <h4>{item.product_name}</h4>
                                        <p>₹ {item.price} × {item.quantity}</p>
                                        <p>Size: {item.size}</p>

                                        {!item.reviewed && (
                                            <button
                                                className="oh-review-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openReviewModal(item.product_id);
                                                }}
                                            >
                                                ⭐ Write Review
                                            </button>
                                        )}
                                        {item.number_plate && (
                                            <p className="oh-number-plate">
                                                <strong>{item.number_plate}</strong>
                                            </p>
                                        )}
                                        {/* 🎨 Color Badge */}
                                        {item.color_name && (
                                            <div className="oh-color-badge">
                                                <span
                                                    className="oh-color-dot"
                                                    style={{
                                                        backgroundColor: item.color_hex || "#ddd"
                                                    }}
                                                ></span>
                                                <span className="oh-color-text">
                                                    🎨{item.color_name}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>


                        <div className="oh-address">
                            <h4>Delivery Details 📦</h4>
                            <p><strong>{order.address.full_name}</strong></p>
                            <p>{order.address.phone}</p>
                            <p>
                                {order.address.address_line1}, {order.address.city}
                            </p>
                            <p>
                                {order.address.state} - {order.address.pincode}
                            </p>
                        </div>
                    </div>

                    {reviewProduct && (
                        <div className="review-overlay">
                            <div className="review-modal">

                                <h3>Rate this product</h3>

                                <div className="review-stars">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <span
                                            key={star}
                                            className={star <= rating ? "star active" : "star"}
                                            onClick={() => setRating(star)}
                                        >
                                            ★
                                        </span>
                                    ))}
                                </div>

                                <textarea
                                    placeholder="Share your experience..."
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />

                                <div className="review-actions">
                                    <button className="cancel-btn" onClick={() => setReviewProduct(null)}>
                                        Cancel
                                    </button>

                                    <button className="submit-btn" onClick={submitReview}>
                                        Submit Review
                                    </button>
                                </div>

                            </div>
                        </div>
                    )}

                    <div className="oh-footer">
                        <strong>Total: ₹ {order.total_amount}</strong>
                        <button
                            className="oh-invoice-btn"
                            onClick={() => downloadInvoice(order.id)}
                        >
                            Download Invoice 🧾
                        </button>
                    </div>

                </div>
            ))}
        </div>
    );
}

export default OrderHistory;
